// assets
import {
  BankOutlined,
  UserOutlined,
  SnippetsOutlined,
  ShoppingOutlined,
  ContainerOutlined,
  PlusCircleOutlined,
  DollarOutlined,
  TableOutlined
} from '@ant-design/icons';

import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
// ==============================|| MENU ITEMS - ADMIN ||============================== //

const admin = {
  id: 'admin',
  title: 'Admin',
  type: 'admin',
  children: [
    {
      id: 'manageusers',
      title: ' Manage Users',
      type: 'item',
      url: '/admin/manageUsers',
      icon: UserOutlined,
      breadcrumbs: false,
    },
    {
      id: 'managecompanies',
      title: ' Manage Companies',
      type: 'item',
      url: '/admin/manageCompanies',
      icon: BankOutlined,
      breadcrumbs: false,
    },
    {
      id: 'manageauctions',
      title: 'Manage Auctions',
      type: 'item',
      url: '/admin/auctionCalendar',
      icon: TimeToLeaveIcon,
      breadcrumbs: false,
    },
    {
      id: 'managebids',
      title: 'Manage Bids',
      type: 'item',
      url: '/admin/manageBids',
      icon: SnippetsOutlined,
      breadcrumbs: false,
    },
    {
        id: 'Vehicles',
        title: 'Manage Vehicles',
        type: 'nestedparent-item',
        url: '/admin/vehicleList',
        icon: TimeToLeaveIcon,
        breadcrumbs: false,
    },
    {
        id: 'VehiclesSheet',
        title: 'Vehicles Sheet',
        type: 'nestedchildren-item',
        url: '/admin/vehicleSheet',
        icon: TableOutlined,
        breadcrumbs: false,
        parentItemId: "Vehicles"
    },
    {
      id: 'NewVehicle',
      title: 'Add Vehicle',
      type: 'item',
      url: '/admin/createVehicle',
      icon: PlusCircleOutlined,
      breadcrumbs: false,
    },
    {
      id: 'ManualOffer',
      title: 'Manual Offer',
      type: 'item',
      url: '/admin/manualOffer',
      icon: DollarOutlined,
      breadcrumbs: false,
    },
    {
      id: 'manageBuyNow',
      title: 'Manage Buy Now',
      type: 'item',
      url: '/admin/manageBuyNow',
      icon: ShoppingOutlined,
      breadcrumbs: false,
    },
    {
      id: 'managemakemodel',
      title: 'Manage Make/Model',
      type: 'item',
      url: '/admin/manageMakeModel',
      icon: ContainerOutlined,
      breadcrumbs: false,
    },
    // // Hidden until further notice
    // {
    //   id: 'submitVehicle',
    //   title: 'Submit Vehicle',
    //   type: 'item',
    //   url: '/submitVehicle',
    //   icon: DescriptionOutlinedIcon,
    //   breadcrumbs: false,
    // },
    // {
    //   id: 'managesubmissions',
    //   title: 'Manage Submissions',
    //   type: 'item',
    //   url: '/admin/submissionList',
    //   icon: ContainerOutlined,
    //   breadcrumbs: false,
    // },
  ],
};

export default admin;
